import * as React from 'react';
import { Group } from '@visx/group';
import { scaleBand } from '@visx/scale';
import { pointer, select } from 'd3';
import { sortAlphabetically } from '../../../utils';
import { BarHorizontal } from './BarHorizontal';
export function BarGroupsHorizontal(props) {
    var _a;
    var series = props.series, accessors = props.accessors, xScale = props.xScale, yScale = props.yScale, colorScale = props.colorScale, crosshatchColor = props.crosshatchColor, activeSet = props.activeSet, onClick = props.onClick, boundedWidth = props.boundedWidth, boundedHeight = props.boundedHeight, tooltip = props.tooltip, _b = props.barPadding, barPadding = _b === void 0 ? 0.1 : _b;
    var groupScale = React.useMemo(function () {
        var inner = typeof barPadding === 'object' ? barPadding.inner : undefined;
        var outer = typeof barPadding === 'object' ? barPadding.outer : undefined;
        return scaleBand({
            domain: sortAlphabetically(Array.from(activeSet.values())),
            padding: typeof barPadding === 'number' ? barPadding : undefined,
            paddingInner: inner,
            paddingOuter: outer
        }).range([0, yScale.bandwidth()]);
    }, [activeSet]);
    // state
    var _c = React.useState(undefined), currentSeries = _c[0], setCurrentSeries = _c[1];
    // handlers
    var handleBarClick = function (barGroupId) { return function () {
        if (onClick === undefined)
            return;
        onClick(series[barGroupId]);
    }; };
    // tooltip
    var tooltipRef = React.useRef(null);
    var tooltipContentRef = React.useRef(null);
    var tooltipTrackRef = React.useRef(null);
    var handleMouseMove = React.useCallback(function (event) {
        var _a, _b;
        if (tooltip === undefined)
            return;
        if (tooltipRef.current === null)
            return;
        if (tooltipTrackRef.current === null)
            return;
        if (tooltipContentRef.current === null)
            return;
        var _c = (_a = pointer(event, tooltipTrackRef.current)) !== null && _a !== void 0 ? _a : [0, 0], mouseX = _c[0], mouseY = _c[1];
        var tipContentNode = tooltipContentRef.current;
        var tipWidth = (_b = tooltip.width) !== null && _b !== void 0 ? _b : 240;
        var x = mouseX + tipWidth > boundedWidth
            ? mouseX - (tipWidth + 10)
            : mouseX + 10;
        // if overflowing bottom, stick bottom of the tooltip to the bottom of the chart
        var y = mouseY + tipContentNode.getBoundingClientRect().height < boundedHeight
            ? mouseY
            : boundedHeight - tipContentNode.getBoundingClientRect().height;
        // TODO: memo select() call?
        select(tooltipRef.current)
            .attr('x', "" + x)
            .attr('y', "" + y)
            .attr('opacity', 1);
    }, [series, accessors, boundedWidth, boundedHeight]);
    var handleMouseLeave = React.useCallback(function () {
        select(tooltipRef.current).attr('opacity', 0);
        setCurrentSeries(undefined);
    }, [series, accessors]);
    var handleMouseEnter = React.useCallback(function (s) { return function () {
        setCurrentSeries(s);
    }; }, []);
    return (React.createElement(Group, null,
        Object.values(series).map(function (s) {
            var barGroupId = accessors.key(s);
            return (React.createElement(Group, { key: accessors.key(s) },
                React.createElement(Group, { top: yScale(accessors.key(s)) }, Object.entries(accessors.data(s)).map(function (_a) {
                    var _b;
                    var datumKey = _a[0], value = _a[1];
                    if (!activeSet.has(datumKey))
                        return null;
                    return (React.createElement(BarHorizontal, { colorScale: colorScale, barScale: groupScale, crosshatchColor: crosshatchColor, xScale: xScale, id: datumKey, key: "bar-group-bar-" + datumKey + "-" + accessors.name(s), x1: (_b = accessors.x1) === null || _b === void 0 ? void 0 : _b.call(accessors, value), x: accessors.x(value) }));
                })),
                React.createElement("rect", { fill: "transparent", height: yScale.bandwidth(), cursor: onClick !== undefined ? 'pointer' : 'auto', y: yScale(accessors.key(s)), width: boundedWidth, ref: tooltipTrackRef, onClick: handleBarClick(barGroupId), onMouseMove: handleMouseMove, onMouseEnter: handleMouseEnter(s), onMouseLeave: handleMouseLeave })));
        }),
        tooltip !== undefined && currentSeries !== undefined && (React.createElement("foreignObject", { style: {
                overflow: 'visible'
            }, pointerEvents: "none", opacity: 0, ref: tooltipRef, width: (_a = tooltip.width) !== null && _a !== void 0 ? _a : 240, height: 1 },
            React.createElement("div", { ref: tooltipContentRef },
                React.createElement(tooltip.Component, { series: currentSeries, accessors: accessors, activeSet: activeSet }))))));
}
//# sourceMappingURL=BarGroupsHorizontal.js.map